import React from 'react';
import { Modal } from '@economic/gaudi';

/**
 * Creates a dialog trigger around the inner element.
 *
 * @example
 *    <DialogTrigger dialog={({ hide }) => <CreateCampaignForm onCancel={hide} />}>
 *        {({ show }) => (
 *            <Button variant="primary" onClick={show} type="primary">
 *                Click me to show dialog
 *            </Button>
 *        )}
 *    </DialogTrigger>
 *
 * @param {*} { children, dialog: createDialog, onHide, ...props }
 */
export default function DialogTrigger({ children, dialog: createDialog, onHide, width, style, ...props }: any) {
    const [visible, setVisibility] = React.useState(false);

    const show = () => {
        setVisibility(true);
    };
    const hide = args => {
        if (onHide) onHide(args);
        setVisibility(false);
    };

    return (
        <>
            {children({ show, hide })}
            {visible && (
                <Modal {...props} onHide={hide} visible={visible} style={{ width: width, ...style }}>
                    {createDialog({ hide })}
                </Modal>
            )}
        </>
    );
}
